export default __webpack_public_path__ + "static/media/icon-call.a4269a72.svg";